import React, { useState } from "react";
import { PropertyPanel } from "@showitinc/showit-wc";
import DesignSettingsButtonsStyles from "./DesignSettingsButtonsStyles";
import DesignSettingsButtonsPreview from "./DesignSettingsButtonsPreview";
import {
  handleThemeLinkInheritanceFromPropInfo,
  applyPropInfoToTheme,
} from "../../utils/SyncUtils";
import ActiveBlockContainerStore from "../../stores/ActiveBlockContainerStore.mjs";
import styles from "./DesignSettingsButtons.module.css";
import AppConstants from "../../constants/AppConstants";

const { BUTTON_PANEL_STATE_PRIMARY, BUTTON_PANEL_TAB_STATE_REGULAR } = AppConstants;

/**
 * Button design settings panel with controls and preview
 * @param {Object} props
 * @param {Object} props.theme - Theme object with button styles
 * @param {Function} props.setTheme - Theme update function
 * @param {number} props.panelHeight - Panel height in pixels
 * @param {Object} props.designContext - Design context object
 * @returns {React.ReactElement}
 */
const DesignSettingsButtons = ({ theme: newTheme, setTheme, panelHeight, designContext }) => {
  const [uiState, setUiState] = useState({
    selectedPanel: BUTTON_PANEL_STATE_PRIMARY,
    primaryTabState: BUTTON_PANEL_TAB_STATE_REGULAR,
    secondaryTabState: BUTTON_PANEL_TAB_STATE_REGULAR,
  });
  const selectedLayout = ActiveBlockContainerStore.getSelectedLayout();

  /**
   * Updates theme with button property changes
   * @param {Object|Array} initialPropInfo - Property info object(s)
   */
  const _onPropChange = (initialPropInfo) => {
    let updatedTheme = newTheme;
    const propInfo = !Array.isArray(initialPropInfo) ? [initialPropInfo] : initialPropInfo;

    if (propInfo.length === 1) {
      updatedTheme = handleThemeLinkInheritanceFromPropInfo(updatedTheme, propInfo);
    } else {
      propInfo.forEach((propData) => {
        updatedTheme = applyPropInfoToTheme(updatedTheme, propData);
      });
    }

    setTheme(updatedTheme);
  };

  const themeStyles = newTheme.get("styles");
  const palette = newTheme.get("colors").toJS();

  return (
    <div className={styles.root} style={{ maxHeight: panelHeight }}>
      <PropertyPanel className={styles["property-panel"]}>
        <DesignSettingsButtonsStyles
          themeStyles={themeStyles}
          selectedLayout={selectedLayout}
          onChange={_onPropChange}
          uiState={uiState}
          setUiState={setUiState}
          palette={palette}
        />
      </PropertyPanel>
      <DesignSettingsButtonsPreview
        selectedLayout={selectedLayout}
        newTheme={newTheme}
        designContext={designContext}
        uiState={uiState}
        setUiState={setUiState}
      />
    </div>
  );
};

export default DesignSettingsButtons;
